import { render, staticRenderFns } from "./ComentarBox.vue?vue&type=template&id=54718ee2&scoped=true&"
import script from "./ComentarBox.vue?vue&type=script&lang=js&"
export * from "./ComentarBox.vue?vue&type=script&lang=js&"
import style0 from "./ComentarBox.vue?vue&type=style&index=0&id=54718ee2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54718ee2",
  null
  
)

export default component.exports